import { DocumentoDTO } from "../dto/documentoDTO";
import { Injectable } from "@angular/core";
import { MapperInterface } from "./mapper-inteface";
import { DocumentoVO } from "../vo/documentoVO";
import { MapperDatiPersonali } from "./mapper-dati-personali";
import { MapperTipologiaDocumento } from "./mapper-tipologia-documento";
import { AutoreDTO } from "../dto/autoreDTO";
import { UtenteDTO } from "../dto/utenteDTO";
import { DatiVersionamentoDocumentoDTO } from "../dto/dati-versionamento-documentoDTO";
import { MapperUtente } from "./mapper-utente";
import { MapperAutore } from "./mapper-autore";
import { MapperDatiFirma } from "./mapper-dati-firma";
import { MapperCampoSpecificoFascicolo } from "./mapper-campo-specifico-fascicolo";
import { MapperVersionamentoDocumento } from "./mapper-versionamento-documento";
import { MapperLingua } from "./mapper-lingua";

@Injectable({
  providedIn: "root",
})
export class MapperDocumento
  implements MapperInterface<DocumentoDTO, DocumentoVO> {
  constructor(
    private mapperDatiPrivacy: MapperDatiPersonali,
    private autoreMapper: MapperAutore,
    private datiFirmaMapper: MapperDatiFirma,
    private mapperCampoSpecificoFascicolo: MapperCampoSpecificoFascicolo,
    private mapperTipologiaDocumento: MapperTipologiaDocumento,
    private mapperVersionamentoDocumento: MapperVersionamentoDocumento,
    private mapperLingue: MapperLingua
  ) { }
  convertVoToDto(vo: DocumentoVO): DocumentoDTO {
    console.log("mappr doc", JSON.stringify(vo));
    if (vo != null) {
      const dto = new DocumentoDTO();
      // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
      dto.primario = vo.primario;
      dto.tipoDocumento = this.mapperTipologiaDocumento.convertVoToDto(
        vo.tipologiaDocumento
      );
      dto.codiceTipologia = vo.codiceTipologia;
      dto.cartaceo = vo.cartaceo;
      dto.dataManuale = vo.dataManuale;
      dto.dataInserimento = vo.dataInserimento;
      dto.dataUltimaModifica = vo.dataUltimaModifica;
      if (vo.datiFirma !== null && vo.datiFirma !== undefined) {
        dto.datiFirma = this.datiFirmaMapper.convertVoToDto(vo.datiFirma);
      }
      dto.datiPersonali = this.mapperDatiPrivacy.convertVoToDto(
        vo.datiPersonali
      );
      dto.hash = vo.hash;
      dto.nome = vo.nome;
      dto.descrizione = vo.descrizione;
      dto.collocazioneFisica = vo.collocazioneFisica;
      dto.preview = vo.preview;
      dto.verificaFirma = vo.verificaFirma;
      dto.idRepository = vo.idRepository;
      dto.tipoSupportoOriginale = vo.tipoSupportoOriginale;
      dto.tipoDocumentoDigitale = vo.tipoDocumentoDigitale;
      dto.campiSpecifici = this.mapperCampoSpecificoFascicolo.convertListVoToDto(
        vo.campiSpecifici
      );
      const datiVer = new DatiVersionamentoDocumentoDTO();
      datiVer.versione = "1.0";
      dto.datiVersionamento = datiVer;
      dto.riservato = vo.riservato;
      dto.dimensioni = vo.dimensioni;
      if (
        vo.autore !== null &&
        vo.autore !== undefined &&
        vo.autore.utente !== null
      ) {
        dto.autore = this.autoreMapper.convertVoToDto(vo.autore);
      }
      if (vo.firmatario != null && vo.firmatario !== undefined) {
        dto.firmatario = this.autoreMapper.convertListVoToDto(vo.firmatario);
      }
      dto.lingue = this.mapperLingue.convertListVoToDto(vo.lingue);
      dto.pubblicabile = vo.pubblicabile;
      dto.contieneDatiPersonali = vo.contieneDatiPersonali;
      dto.idAllegatoPadre = vo.idAllegatoPadre;
      dto.codice = vo.codice;

      console.log("mappr doc end", JSON.stringify(dto));
      return dto;
    } else {
      return null;
    }
  }

  convertDtoToVo(dto: DocumentoDTO): DocumentoVO {
    if (dto != null) {
      const vo = new DocumentoVO();
      // ATTENZIONE!! fare mapper questa riga funge solo se DTO e VO sono identici
      vo.primario = dto.primario;
      vo.tipologiaDocumento = this.mapperTipologiaDocumento.convertDtoToVo(
        dto.tipoDocumento
      );
      vo.codiceTipologia = dto.codiceTipologia;
      vo.dataManuale = dto.dataManuale;
      vo.dataInserimento = dto.dataInserimento;
      vo.dataUltimaModifica = dto.dataUltimaModifica;
      if (dto.datiFirma !== null && dto.datiFirma !== undefined) {
        vo.datiFirma = this.datiFirmaMapper.convertDtoToVo(dto.datiFirma);
      }
      vo.datiVersionamento = this.mapperVersionamentoDocumento.convertDtoToVo(
        dto.datiVersionamento
      );
      vo.datiPersonali = this.mapperDatiPrivacy.convertDtoToVo(
        dto.datiPersonali
      );
      vo.hash = dto.hash;
      vo.nome = dto.nome;
      vo.descrizione = dto.descrizione;
      vo.cartaceo = dto.cartaceo;
      if (
        vo.nome != null &&
        vo.nome !== undefined &&
        vo.nome.substring(vo.nome.length - 3, vo.nome.length).toLowerCase() !==
        "xml" &&
        vo.nome.substring(vo.nome.length - 3, vo.nome.length).toLowerCase() !==
        "eml"
      ) {
        vo.preview = true;
      } else {
        vo.preview = false;
      }
      vo.verificaFirma = dto.verificaFirma;
      vo.dimensioni = dto.dimensioni;
      vo.idRepository = dto.idRepository;
      vo.collocazioneFisica = dto.collocazioneFisica;
      if (dto.autore !== null && dto.autore !== undefined) {
        vo.autore = this.autoreMapper.convertDtoToVo(dto.autore);
      }
      vo.firmatario = this.autoreMapper.convertListDtoToVo(dto.firmatario);
      vo.tipoSupportoOriginale = dto.tipoSupportoOriginale;
      vo.tipoDocumentoDigitale = dto.tipoDocumentoDigitale;
      vo.riservato = dto.riservato;
      vo.campiSpecifici = this.mapperCampoSpecificoFascicolo.convertListDtoToVo(
        dto.campiSpecifici
      );
      vo.esisteRichiestaFirma = dto.esisteRichiestaFirma;
      vo.statoRichiestaFirma = dto.statoRichiestaFirma;
      vo.motivoFirma = dto.motivoFirma;
      if (
        dto.nome != null &&
        (dto.nome
          .substring(dto.nome.length - 3, dto.nome.length)
          .toLowerCase() === "pdf" ||
          dto.nome
            .substring(dto.nome.length - 3, dto.nome.length)
            .toLowerCase() === "p7m" ||
          dto.nome
            .substring(dto.nome.length - 3, dto.nome.length)
            .toLowerCase() === "eml")
      ) {
        vo.copiaConforme = true;
      } else {
        vo.copiaConforme = false;
      }
      vo.lingue = this.mapperLingue.convertListDtoToVo(dto.lingue);
      vo.pubblicabile = dto.pubblicabile;
      vo.contieneDatiPersonali = dto.contieneDatiPersonali;
      vo.idAllegatoPadre = dto.idAllegatoPadre;
      vo.codice = dto.codice;
      return vo;
    } else {
      return null;
    }
  }
  convertListVoToDto(e: DocumentoVO[]): DocumentoDTO[] {
    if (e != null) {
      return e.map((vo) => this.convertVoToDto(vo));
    } else {
      return null;
    }
  }
  convertListDtoToVo(t: DocumentoDTO[]): DocumentoVO[] {
    if (t != null) {
      return t.map((vo) => this.convertDtoToVo(vo));
    } else {
      return null;
    }
  }
}
